<template>
    <v-list id="main-menu" dense>
        <v-row v-if="toggle !== undefined" class="mr-2" justify="end">
            <v-btn x-small color="transparent" depressed @click="handleToggle">
                <v-icon center color="primary" v-if="!toggle">fas fa-angle-double-right</v-icon>
                <v-icon center color="primary" v-if="toggle">fas fa-angle-double-left</v-icon>
            </v-btn>
        </v-row>
        <div v-for="(nav_item, k) in filtered_menu" :key="k" :is="nav_item.children.length == 0 ? 'menu-item' : 'menu-group'" :icon="nav_item.icon" :path="nav_item.to" :href="nav_item.href" :title="nav_item.label" :update="update">
            <sub-menu-item v-for="(nav_child, k) in nav_item.children" :key="k" small icon="" :path="nav_child.to" :href="nav_child.href">
                {{nav_child.label}}
            </sub-menu-item>
        </div>
        <menu-group v-if="hasRole(['Staff', 'SuperAdmin']) && !isImpersonating" icon="fas fa-user-shield" title="Admin" route="Admin" :update="update">
            <sub-menu-item v-for="item in tenantAdminMenu" :key="item.text" icon="fas fa-angle-right" small :route="item.route">
                {{ item.text }}
            </sub-menu-item>
        </menu-group>
        <menu-group v-if="hasPermission('manage:Content') && !isImpersonating" :update="update" icon="icon-q-content-editor" title="Content Editor" route="Admin">
            <sub-menu-item v-for="item in contentManagerMenu" :key="item.text" icon="fas fa-angle-right" small :route="item.route">
                {{ item.text }}
            </sub-menu-item>
        </menu-group>
        <menu-group v-if="hasRole('SuperAdmin') && !isImpersonating" icon="fab fa-fort-awesome" title="SuperAdmin" route="Admin" :update="update">
            <sub-menu-item v-for="item in superAdminMenu" :key="item.text" icon="fas fa-angle-right" small :route="item.route">
                {{ item.text }}
            </sub-menu-item>
        </menu-group>
        <!--<menu-item icon="fas fa-tools" :click="toggleUtilityDrawer">Utility Drawer</menu-item>-->
    </v-list>
</template>
<script>
import MenuItem from './MenuItem.vue';
import MenuGroup from './MenuGroup.vue';
import SubMenuItem from './SubMenuItem.vue';

export default {
    props: {
        toggle: { type: Boolean, default: undefined },
    },
    data: function() {
        return {
            update: 0,
            toggle_left_nav: false
        }
    },
    methods: {
        allowDivision(item) {
            var g = this
            if (item.divisions == 'Any') {
                return true
            }
            return g.hasDivision(item.divisions)
        },
        collapse: function() {
            this.update++;
        },
        toggleMobileMenu: function(menus) {
            this.drawerMobile = !this.drawerMobile;
        },
        toggleRightMenu: function(menus) {
            this.drawerRight = !this.drawerRight;
        },
        handleToggle: function(v) {
            this.$emit('toggle-menu-updated', !this.toggle)
        }
    },
    computed: {
        filtered_menu: function() {
            var m = [];
            var g = this;
            this.user.nav_menu.forEach(function(item) {
                if (g.current_tenant.ID == item.tenant_id && item.menu == 'Left Nav') {
                    var _item = { ...item }
                    _item.children = [];
                    item.children.forEach(function(child) {
                        if (g.current_tenant.ID == child.tenant_id) {
                            _item.children.push(child)
                        }
                    })
                    m.push(_item);
                }
            })
            return m
        },
        contentManagerMenu() {
            if (!this.hasPermission('manage:Content') || this.isImpersonating) {
                return [];
            }

            return [
                { route: 'CMS', text: 'Pages' },
                { route: { name: 'CMSEditor', params: { page_id: 'new' } }, text: 'New Page' },
                { route: 'MediaLibrary', text: 'Media Library' },
                { route: 'DocumentLibrary', text: 'Document Library' },
                { route: 'Manage Categories', text: 'Categories' },
                //{ route: 'CarrierPages', text: 'Carrier Pages' },
                //{ route: 'CarrierProducts', text: 'Carrier Products' },
                { route: { name: 'NavEditor' }, text: 'Nav Editor' },
                { route: 'TenantThemeSettings', text: 'Theme' },
            ];
        },
        tenantAdminMenu () {
            if (!this.hasRole(['Staff', 'SuperAdmin']) || this.isImpersonating) {
                return [];
            }
            const tenant_routes = [
                { route: 'ManageTenantStaff', text: 'Manage Staff Accounts' },
                { route: 'AdminAgentDirectory', text: 'Agent Directory' },
                this.hasRole('SuperAdmin') &&
                    { route: 'AdminCreateAgent', text: 'New Agent' },
                { route: 'AdminAgencyStructure', text: 'Agency Structure' },
                { route: 'AdminScoreCardsHQ', text: 'HQ Stats' },
                this.tenantHasFeature('DTCWidget') &&
                    { route: 'AffiliateWidget', text: 'Affiliate DTC Widget' },
            ]
            return tenant_routes.filter(Boolean)
        },
        superAdminMenu() {
            if (!this.hasRole('SuperAdmin') || this.isImpersonating) {
                return [];
            }
            return [
                { route: 'Manage Tenants', text: 'Manage Tenants' },
                { route: 'AgentAuditReport', text: 'Audit Logs' },
                { route: 'CarrierList', text: 'Carrier Library' },
                { route: 'ProductList', text: 'Product Library' },
                { route: 'AdminLogs', text: 'Logs' },
                { route: 'API', text: 'API & Cache' },
                { route: 'BulkUploads', text: 'Bulk Uploads' },
            ];
        },
    },
    components: {
        MenuItem,
        MenuGroup,
        SubMenuItem
    }
}
</script>